export default __webpack_public_path__ + "static/media/4.91c120f8.jpg";